import { render, staticRenderFns } from "./BrandPromotion.vue?vue&type=template&id=13e30838&scoped=true&"
import script from "./BrandPromotion.vue?vue&type=script&lang=js&"
export * from "./BrandPromotion.vue?vue&type=script&lang=js&"
import style0 from "./BrandPromotion.vue?vue&type=style&index=0&id=13e30838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e30838",
  null
  
)

export default component.exports